import {rootLogger} from '../logger';
import {useSettingsMenuActions} from '../plugins/hooks/useSettingsMenuAction';
import {useInfinityContext} from '../hooks/useInfinityContext';

import {useMe} from './useMe';
import {useFeedback} from './useFeedback';
import {isAcLayout} from '../utils/isAcLayout';
import {useCurrentHostLayout} from './meeting';

const downloadLogWithName = () => rootLogger.downloadLog();

export const useUserMenuContent = ({isInMeeting}: {isInMeeting: boolean}) => {
    const infinity = useInfinityContext();
    const me = useMe(infinity.getMe);
    const meeting = infinity.getMeeting();
    const isDirectMedia = meeting.getConferenceFeatureFlags()?.isDirectMedia;
    const currentHostLayout = useCurrentHostLayout(
        meeting.getCurrentHostLayout,
    );
    const canChangeLayout = me?.canChangeLayout;

    const canChangePersonalLayout =
        me?.canReceivePersonalMix && !isAcLayout(currentHostLayout);

    const {isFeedbackEnabled, openFeedbackForm} = useFeedback();

    const pluginActions = useSettingsMenuActions(me, isInMeeting);

    return {
        downloadLogWithName,
        canChangeLayout,
        canChangePersonalLayout,
        isDirectMedia,
        isFeedbackEnabled,
        openFeedbackForm,
        pluginActions,
    };
};
